import { Outlet } from "react-router-dom";

const PTMasterLayout = () => {
  return <Outlet />;
};

export default PTMasterLayout;